import { NetworkUrlOfChainId, EthRPCEndpoints, ChainType, ThetaRPCEndpoints } from 'common/constants';

const host = 'https://testnet-explorer.thetatoken.org';
const hostApi = 'https://testnet-explorer-api.thetatoken.org';
const hostWs = 'https://testnet-explorer-ws.thetatoken.org';
const config = {
    restApi: {
        host: hostApi,
        port: 443
    },
    socketApi: {
        host: hostWs,
        port: 443
    },
    defaultThetaChainID: NetworkUrlOfChainId[host],
    ethRPCEndpoint: EthRPCEndpoints[host],
    thetaRPCEndPoint: ThetaRPCEndpoints[host],
    chainInfo: {
        metachain: {
            host: "https://testnet-metachain-explorer.thetatoken.org"
        },
        mainchain: {
            name: 'Theta Testnet Main Chain',
            description: 'The Main Chain serves as the Metachain Hub and coordinates the Subchains.',
            host: 'https://testnet-explorer.thetatoken.org',
            logoName: "theta",
            hostApi: 'https://testnet-explorer-api.thetatoken.org',
            hostWs: 'https://testnet-explorer-ws.thetatoken.org',
            restApiPort: 443,
            socketApiPort: 443
        },
       subchains: []
    },
    chainName: 'Theta Testnet Main Chain',
    chainType: ChainType.MAINCHAIN,
    tokenMap: {
        TDrop: '0x08a0c0e8EFd07A98db11d79165063B6Bc2469ADF', //address for testnet
        TFuelTransfer: ['0x859938d8b3ff02b29cb491b8e0996eb1c86d89f1','0x216871f4c3b11369750f4b215aeadf0129bdbf58'],
    },
    disableSSL: true
};
export default config;